<template>
  <div>
    <v-toolbar flat color="white">
      <v-btn color="primary" dark class="mb-2" @click="newDialog = true" round
        >ADD MODEL</v-btn
      >
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    </v-toolbar>

    <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD MODEL</h1>
          <v-spacer></v-spacer>
           <v-btn color="white" flat @click="close">X</v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap justify-center>
              <v-flex xs3 ml-1>
                <v-text-field
                  v-model="editedItem.name"
                  label="*Model Name"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>

               <v-flex xs3 ml-1>
                <v-text-field
                  v-model="editedItem.systemName"
                  label="System Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <!-- <v-flex xs12 >
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.cardImage"
                    label="ImageURL*"
                    hint="Link to an image"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex> -->

              <v-flex xs3 ml-1>
                <v-select
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Device Make"
                  :items="deviceMake"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.deviceMakeId"
                >
                </v-select>
              </v-flex>

              <v-flex xs3 ml-1>
                <v-select
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Device Type"
                  :items="deviceType"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.deviceTypeId"
                >
                </v-select>
              </v-flex>
               <v-flex xs10 mx-1 
                ><h3 class="grey--text">Model Type Settings</h3></v-flex
              >
               <v-flex xs3 mx-1>
                <v-checkbox
                  label="Headend Equipment"
                  v-model="editedItem.isHeadend"
                  @change="editedItem.isHeadend?editedItem.isCpe=false:editedItem.isCpe=editedItem.isCpe"
                ></v-checkbox>
              </v-flex>

 <v-flex xs3 mx-1>
                <v-checkbox
                  label="CPE"
                  v-model="editedItem.isCpe"
                  @change="editedItem.isCpe?editedItem.isHeadend=false:editedItem.isHeadend=editedItem.isHeadend"
                ></v-checkbox>
              </v-flex>

 <v-flex xs3 mx-1>
                <v-checkbox
                  label="Wireless"
                  v-model="editedItem.isWireless"
                ></v-checkbox>
              </v-flex>

               <v-flex xs10 mx-1 v-if="editedItem.isWireless"
                ><h3 class="grey--text">Wireless Settings</h3></v-flex
              >
              <v-flex xs4 mx-1 v-if="editedItem.isWireless">
                <v-text-field
                  label="Range (m)"
                  type="number"
                  min="1"
                  v-model="editedItem.distanceRange"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 mx-1 v-if="editedItem.isWireless">
                <v-text-field
                  label="Range Angle (degrees)"
                  type="number"
                  min="1"
                  v-model="editedItem.angleRange"
                ></v-text-field>
              </v-flex>


              <v-flex xs4 mx-1>
                <v-checkbox
                  label="List device as sellable"
                  v-model="editedItem.sellable"
                ></v-checkbox>
              </v-flex>
              <v-flex xs4 v-if="accountingInfo.length>0&&editedItem.sellable">
            <v-select v-if="$store.state.currentOrg.org.accountingSystem == 'SageOne'"
            :items="accountingInfo"
            item-text="name"
            item-value="id"
            label="Associated Account"
            v-model="editedItem.accountCode"
            ></v-select>
          </v-flex>

              <v-flex xs4 mx-1 v-if="editedItem.sellable">
                <v-text-field
                  type="number"
                  
                  label="Selling Price (incl. VAT)"
                  v-model="editedItem.priceInclVat"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 mx-1 v-if="editedItem.sellable">
                <!-- <v-btn v-if="editedItem.sellable" round color="primary" class="white--text">Upload Image</v-btn> -->
                <!-- <v-btn v-if="editedItem.sellable"  class="primary" dark round @click="$refs.file.click()">Upload Image</v-btn> -->
                <input
                  style="display: none"
                  class="file-input"
                  @change="selectFile($event)"
                  ref="file"
                  type="file"
                />
                <v-img
                  v-if="editedItem.image !== null"
                  :key="key"
                  :src="editedItem.image"
                  max-height="150px"
                  contain
                ></v-img>
                <v-btn
                  v-if="editedItem.sellable && !editedItem.image"
                  class="primary"
                  dark
                  round
                  @click="$refs.file.click()"
                  >Upload Image</v-btn
                >
                <v-btn
                  v-else-if="editedItem.sellable && editedItem.image"
                  class="primary"
                  dark
                  round
                  @click="$refs.file.click()"
                  >Change Image</v-btn
                >
              </v-flex>
              <v-flex xs10 mx-1 v-if="editedItem.sellable">
                <v-textarea
                  v-if="editedItem.sellable"
                  label="Product Description"
                  v-model="editedItem.description"
                ></v-textarea>
              </v-flex>

              <v-flex xs10 mx-1 v-if="editedItem.isCpe"
                ><h3 class="grey--text">Available Services</h3></v-flex
              >
                 <v-flex v-if="editedItem.isCpe">
                <v-checkbox
                  label="High Speed Internet"
                  v-model="editedItem.isHsi"
                ></v-checkbox>
              </v-flex>
              <v-flex v-if="editedItem.isCpe">
                <v-checkbox
                  label="Wifi"
                  v-model="editedItem.isWifi"
                ></v-checkbox>
              </v-flex>
              <v-flex v-if="editedItem.isCpe">
                <v-checkbox
                  label="VOIP"
                  v-model="editedItem.isVoip"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-center wrap v-if="editedItem.isHsi">
              <v-flex xs10 mx-1
                ><h3 class="grey--text">
                  Allowed Internet Configuration
                </h3></v-flex
              >
              <v-flex xs3 mx-1>
                <v-checkbox
                  label="One Device Policy"
                  v-model="editedItem.oneDevicePolicy"
                ></v-checkbox>
              </v-flex>
              <v-flex xs3 mx-1>
                <v-checkbox
                  label="Two Device Policy"
                  v-model="editedItem.twoDevicePolicy"
                ></v-checkbox>
              </v-flex>
              <v-flex xs3 mx-1>
                <v-select
                  v-if="
                    editedItem.oneDevicePolicy && editedItem.twoDevicePolicy
                  "
                  label="Default Policy"
                  v-model="editedItem.defaultPolicy"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout v-if="editedItem.isWifi" justify-center align-center wrap>
              <v-flex xs10 mx-1
                ><h3 class="grey--text">Available WiFi</h3></v-flex
              >
              <v-flex>
                <v-checkbox
                  label="2.4Ghz Wifi"
                  v-model="editedItem.twoGhzWifi"
                ></v-checkbox>
              </v-flex>
              <v-flex>
                <v-checkbox
                  label="5Ghz Wifi"
                  v-model="editedItem.fiveGhzWifi"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-layout justify-center>
           
            <v-btn
              color="primary"
              v-if="editedItem.sellable && editedItem.priceInclVat"
              round
              @click="saveNew"
              >Save</v-btn
            >
            <v-btn
              color="primary"
              v-else-if="
                !editedItem.sellable &&
                editedItem.name &&
                editedItem.deviceTypeId &&
                editedItem.deviceMakeId
              "
              round
              @click="saveNew"
              >Save</v-btn
            >
            <v-btn round v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT MODEL</h1>
          <v-spacer></v-spacer>
           <v-btn color="white" flat @click="close">X</v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap justify-center>
              <v-flex xs3 ml-1>
                <v-text-field
                  v-model="editedItem.name"
                  label="*Model Name"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
               <v-flex xs3 ml-1>
                <v-text-field
                  v-model="editedItem.systemName"
                  label="System Name"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs3 ml-1>
                <v-select
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Device Make"
                  :items="deviceMake"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.deviceMakeId"
                >
                </v-select>
              </v-flex>

              <v-flex xs3 ml-1>
                <v-select
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Device Type"
                  :items="deviceType"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.deviceTypeId"
                >
                </v-select>
              </v-flex>
              <v-flex xs3 ml-1>
                <v-btn @click="mergeModel = true,editedItem.useMergedSystemName=true" round color="primary">Merge Models<v-icon>merge</v-icon></v-btn>
              </v-flex>
               <v-flex xs10 mx-1 
                ><h3 class="grey--text">Model Type Settings</h3></v-flex
              >
               <v-flex xs3 mx-1>
                <v-checkbox
                  label="Headend Equipment"
                  v-model="editedItem.isHeadend"
                  @change="editedItem.isHeadend?editedItem.isCpe=false:editedItem.isCpe=editedItem.isCpe"
                ></v-checkbox>
              </v-flex>

 <v-flex xs3 mx-1>
                <v-checkbox
                  label="CPE"
                  v-model="editedItem.isCpe"
                  @change="editedItem.isCpe?editedItem.isHeadend=false:editedItem.isHeadend=editedItem.isHeadend"
                ></v-checkbox>
              </v-flex>

 <v-flex xs3 mx-1>
                <v-checkbox
                  label="Wireless"
                  v-model="editedItem.isWireless"
                ></v-checkbox>
              </v-flex>

               <v-flex xs10 mx-1 v-if="editedItem.isWireless"
                ><h3 class="grey--text">Wireless Settings</h3></v-flex
              >
              <v-flex xs4 mx-1 v-if="editedItem.isWireless">
                <v-text-field
                  label="Range (m)"
                  type="number"
                  min="1"
                  v-model="editedItem.distanceRange"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 mx-1 v-if="editedItem.isWireless">
                <v-text-field
                  label="Range Angle (degrees)"
                  type="number"
                  min="1"
                  v-model="editedItem.angleRange"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 mx-1>
                <v-checkbox
                  label="List device as sellable"
                  v-model="editedItem.sellable"
                ></v-checkbox>
              </v-flex>
              <v-flex xs4 v-if="accountingInfo.length>0&&editedItem.sellable">
            <v-select v-if="$store.state.currentOrg.org.accountingSystem == 'SageOne'"
            :items="accountingInfo"
            item-text="name"
            item-value="id"
            label="Associated Account"
            v-model="editedItem.accountCode"
            ></v-select>
          </v-flex>

              <v-flex xs4 mx-1 v-if="editedItem.sellable">
                <v-text-field
                  type="number"
                  v-if="editedItem.sellable"
                  label="Selling Price (incl. VAT)"
                  v-model="editedItem.priceInclVat"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 mx-1 v-if="editedItem.sellable">
                <input
                  style="display: none"
                  class="file-input"
                  @change="selectFile($event)"
                  ref="file"
                  type="file"
                />
                <v-img
                  v-if="editedItem.image !== null"
                  :key="key"
                  :src="editedItem.image"
                  max-height="150px"
                  contain
                ></v-img>
                <v-btn
                  v-if="editedItem.sellable && !editedItem.image"
                  class="primary"
                  dark
                  round
                  @click="$refs.file.click()"
                  >Upload Image</v-btn
                >
                <v-btn
                  v-else-if="editedItem.sellable && editedItem.image"
                  class="primary"
                  dark
                  round
                  @click="$refs.file.click()"
                  >Change Image</v-btn
                >
              </v-flex>
              <v-flex xs10 mx-1 v-if="editedItem.sellable">
                <v-textarea
                  v-if="editedItem.sellable"
                  label="Product Description"
                  v-model="editedItem.description"
                ></v-textarea>
              </v-flex>
              <v-flex xs10 mx-1
                v-if="editedItem.isCpe"><h3 class="grey--text">Available Services</h3></v-flex
              >
              <v-flex v-if="editedItem.isCpe">
                <v-checkbox
                  label="High Speed Internet"
                  v-model="editedItem.isHsi"
                ></v-checkbox>
              </v-flex>
              <v-flex v-if="editedItem.isCpe">
                <v-checkbox
                  label="Wifi"
                  v-model="editedItem.isWifi"
                ></v-checkbox>
              </v-flex>
              <v-flex v-if="editedItem.isCpe">
                <v-checkbox
                  label="VOIP"
                  v-model="editedItem.isVoip"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-center wrap v-if="editedItem.isHsi">
              <v-flex xs10 mx-1
                ><h3 class="grey--text">
                  Allowed Internet Configuration
                </h3></v-flex
              >
              <v-flex xs3 mx-1>
                <v-checkbox
                  label="One Device Policy"
                  v-model="editedItem.oneDevicePolicy"
                ></v-checkbox>
              </v-flex>
              <v-flex xs3 mx-1>
                <v-checkbox
                  label="Two Device Policy"
                  v-model="editedItem.twoDevicePolicy"
                ></v-checkbox>
              </v-flex>
              <v-flex xs3 mx-1>
                <v-select
                  v-if="
                    editedItem.oneDevicePolicy && editedItem.twoDevicePolicy
                  "
                  label="Default Policy"
                  :items="[
                    { value: 'OneDevice', name: 'One Device' },
                    { value: 'TwoDevice', name: 'TwoDevice' },
                  ]"
                  item-text="name"
                  item-value="value"
                  v-model="editedItem.defaultPolicy"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout v-if="editedItem.isWifi" justify-center align-center wrap>
              <v-flex xs10 mx-1
                ><h3 class="grey--text">Available WiFi</h3></v-flex
              >
              <v-flex>
                <v-checkbox
                  label="2.4Ghz Wifi"
                  v-model="editedItem.twoGhzWifi"
                ></v-checkbox>
              </v-flex>
              <v-flex>
                <v-checkbox
                  label="5Ghz Wifi"
                  v-model="editedItem.fiveGhzWifi"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-layout justify-center>
            <!-- <v-btn color="primary" round @click="close">Cancel</v-btn> -->
            <v-btn color="primary" round @click="save">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :items="deviceMakeModels"
      :rows-per-page-items="[25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
        </td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td
          v-if="
            props.item.deviceMakeId !== null &&
            typeof props.item.deviceMake !== 'undefined'
          "
          class="text-xs-center"
        >
          {{ props.item.deviceMake.name }}
        </td>
        <td v-else class="text-xs-center">Not Allocated</td>
        <td class="text-xs-center">{{ props.item.deviceType.name }}</td>
        <td class="text-xs-center" v-if="props.item.isActive">
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
      </template>
      <!-- Custom Row count and Paging text -->
      <template v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of
        {{ props.itemsLength }}</template
      >
      <!-- No data Dispalay -->
    </v-data-table>

<v-dialog persistent v-model="mergeModel" width="750px">
  <v-card v-if="editedItem" :key="mergeKey">
    <v-toolbar flat color="primary">
      <v-toolbar-title style="color: white">
        Merge Models
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat color="white" @click="mergeModel=false,editedItem.mergeDeviceMakeModel=null">X</v-btn>
    </v-toolbar>
    <v-card-text v-if="!editedItem.mergeDeviceMakeModel" :key="mergeKey">
      <v-flex xs12>
        <h3 color="grey">Select a model to merge into</h3>
      </v-flex>
      <v-flex xs6>
        <v-text-field label="Search" v-model="searchMerge" clearable></v-text-field>
      </v-flex>
      <v-data-table
      :headers="mergeHeaders"
      class="elevation-1"
      :search="searchMerge"
      :items="deviceMakeModels.filter(x=>x.id!=editedItem.id)"
      :rows-per-page-items="[10, 25, 50, 100]"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td @click="editedItem.mergeDeviceMakeModel=props.item, mergeKey++" class="text-xs-center">{{ props.item.name }}</td>
        <td
        @click="editedItem.mergeDeviceMakeModel=props.item, mergeKey++"
          v-if="
            props.item.deviceMakeId !== null &&
            typeof props.item.deviceMake !== 'undefined'
          "
          class="text-xs-center"
        >
          {{ props.item.deviceMake.name }}
        </td>
        <td @click="editedItem.mergeDeviceMakeModel=props.item, mergeKey++" v-else class="text-xs-center">Not Allocated</td>
        <td @click="editedItem.mergeDeviceMakeModel=props.item, mergeKey++" class="text-xs-center">{{ props.item.deviceType.name }}</td>
      </template>
      <!-- Custom Row count and Paging text -->
      <template v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of
        {{ props.itemsLength }}</template
      >
      <!-- No data Dispalay -->
    </v-data-table>

    </v-card-text>
    <v-card-text v-else :key="mergeKey">
      <v-layout wrap align-center>
        <v-flex xs12 class="text-xs-center">
          
          <span>Are you sure you want to merge {{editedItem.name}} into {{editedItem.mergeDeviceMakeModel.name}}?</span>
        </v-flex>
      <v-flex xs5>
        <h3>{{editedItem.deviceMake.name}} {{editedItem.name}}</h3>
        <span>{{editedItem.deviceType.name}}</span>
      </v-flex>
      <v-flex xs2>
        <v-icon>east</v-icon>
      </v-flex>
      <v-flex xs5>
        <h3>{{editedItem.mergeDeviceMakeModel.deviceMake.name}} {{editedItem.mergeDeviceMakeModel.name}}</h3>
        <span>{{editedItem.mergeDeviceMakeModel.deviceType.name}}</span>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <v-checkbox :label="`Use ${editedItem.name} as the system name`" v-model="editedItem.useMergedSystemName"></v-checkbox>
        <v-btn color="primary" @click="mergeModels()" round>Submit</v-btn>
      </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>

  </div>
</template>
 
<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
      accountingInfo: [],
      showDetails: true,
      loading: false,
      expand: false,
      search: "",
      searchMerge: '',
      dialog: false,
      newDialog: false,
      key: 0,
      pagination: {},
      mergeModel: false,
      mergeKey:0 ,
      headers: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Device Make",
          align: "center",
          value: "deviceMake.name",
        },
        {
          text: "Device Type",
          align: "center",
          value: "deviceType.name",
        },
        {
          text: "Active",
          align: "center",
          value: "isActive",
        },
      ],
      mergeHeaders:[
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Device Make",
          align: "center",
          value: "deviceMake.name",
        },
        {
          text: "Device Type",
          align: "center",
          value: "deviceType.name",
        },
      ],
      deviceMake: [],
      deviceType: [],
      deviceMakeModels: [],
      editedIndex: -1,
      editedItem: {
        name: "",
        deviceMake: "",
        cardImage: "",
        deviceMakeId: null,
        deviceType: "",
        deviceTypeId: null,
        isHsi: false,
        isWifi: false,
        isVoip: false,
        twoGhzWifi: false,
        fiveGhzWifi: false,
        ports: 0,
        isActive: true,
        isDeleted: false,
        isHeadend: false,
        isCpe: false,
        isWireless: false
      },
      defaultItem: {
        name: "",
        deviceMake: "",
        cardImage: "",
        deviceMakeId: null,
        deviceType: "",
        deviceTypeId: null,
        isHsi: false,
        isWifi: false,
        isVoip: false,
        twoGhzWifi: false,
        fiveGhzWifi: false,
        ports: 0,
        isActive: true,
        isDeleted: false,
        isHeadend: false,
        isCpe: false,
        isWireless: false
      },
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  async created() {
        this.initialize();
      //   if(this.$store.state.currentOrg.org.accountingSystem == 'SageOne'){
      //   if(this.$store.state.currentOrg.org.accountBasedAccounting){
      //   this.fetchSageAccounts()
      //   } else {
      //     this.fetchSageItems()
      //   }
      // }
  },
  methods: {
    async mergeModels(){
      if(this.editedItem.useMergedSystemName){
        this.editedItem.mergeDeviceMakeModel.systemName = this.editedItem.name
      }
      await Api().post('/deviceMakeModels/merge',{
        new: this.editedItem.mergeDeviceMakeModel,
        old: this.editedItem
      }).then(res=>{
        this.mergeModel=false
        this.dialog = false
        this.initialize()
      })
    },
     async fetchSageAccounts(){
      await Api().get('/sageOne/accounts').then(res=>{
        let result = res.data.Results.filter(x=>x.Category.ID == 1)
        this.accountingInfo = result.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },
    async fetchSageItems(){
      await Api().get('/sageOne/items').then(res=>{
        this.accountingInfo = result.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },
    async selectFile(event) {
      let file = event.srcElement.files[0];
      await this.uploadFile(file);
    },
    async uploadFile(file) {
      var reader = await new FileReader();
      await reader.readAsDataURL(file);
      reader.onload = () => {
        this.setResult(reader.result);
      };
      reader.onerror = function () {
        console.log("there are some problems");
      };
    },
    setResult(result) {
      this.editedItem.image = result;
      this.key += 1;
    },
    fetchDeviceMakeModels() {
      this.isLoading = true;
      Api()
        .get("/deviceMakeModels/active")
        .then((response) => {
          this.deviceMakeModels = response.data;
          this.isLoading = false;
        });
    },
    fetchDeviceMakes() {
      Api()
        .get("/deviceMakes/active")
        .then((response) => {
          this.deviceMake = response.data;
        });
    },
    fetchDeviceTypes() {
      Api()
        .get("/deviceTypes/active")
        .then((response) => {
          this.deviceType = response.data;
        });
    },
    initialize() {
      this.fetchDeviceMakeModels();
      this.fetchDeviceMakes();
      this.fetchDeviceTypes();
    },
    editItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.editedIndex = this.deviceMakeModels.indexOf(item);
        this.editedItem = item;
        this.dialog = true;
      }
    },
    deleteItem(id) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm("Are you sure you want to delete this item?") &&
          Api()
            .put("/deviceMakeModels/" + id, {
              isActive: false,
              isDeleted: true,
            })
            .then((response) => {
              this.fetchDeviceMakeModels();
            });
      }
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      let proceed = true;
      if (this.editedItem.oneDevicePolicy && !this.editedItem.twoDevicePolicy) {
        this.editedItem.defaultPolicy = "OneDevice";
      } else if (
        !this.editedItem.oneDevicePolicy &&
        this.editedItem.twoDevicePolicy
      ) {
        this.editedItem.defaultPolicy = "TwoDevice";
      }
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (this.editedItem.deviceMakeId == null) {
        proceed = false;
        confirm("Please fill in a device make.");
      }
      if (this.editedItem.deviceTypeId == null) {
        proceed = false;
        confirm("Please fill in a device type.");
      }
      if (proceed == true) {
        Api()
          .put("/deviceMakeModels/" + this.editedItem.id, {
            accountCode: this.editedItem.accountCode,
            name: this.editedItem.name,
            cardImage: this.editItem.cardImage,
            deviceMakeId: this.editedItem.deviceMakeId,
            deviceTypeId: this.editedItem.deviceTypeId,
            isHsi: this.editedItem.isHsi,
            isWifi: this.editedItem.isWifi,
            isVoip: this.editedItem.isVoip,
            twoGhzWifi: this.editedItem.isWifi
              ? this.editedItem.twoGhzWifi
              : false,
            fiveGhzWifi: this.editedItem.isWifi
              ? this.editedItem.fiveGhzWifi
              : false,
            ports: this.editedItem.ports,
            sellable: this.editedItem.sellable,
            description: this.editedItem.description,
            priceInclVat: this.editedItem.priceInclVat,
            image: this.editedItem.image,
            oneDevicePolicy: this.editedItem.oneDevicePolicy,
            twoDevicePolicy: this.editedItem.twoDevicePolicy,
            defaultPolicy: this.editedItem.defaultPolicy,
            isHeadend: this.editedItem.isHeadend,
            isCpe: this.editedItem.isCpe,
            isWireless: this.editedItem.isWireless,
            distanceRange: this.editedItem.isWireless?this.editedItem.distanceRange:null,
            angleRange: this.editedItem.isWireless?this.editedItem.angleRange:null,
            isDeleted: this.editedItem.isDeleted,
            isActive: this.editedItem.isActive,
          })
          .then((response) => {
            this.fetchDeviceMakeModels();
          });
        this.close();
        Object.assign(this.deviceMakeModels[this.editedIndex], this.editedItem);
      }
    },
    saveNew() {
      let proceed = true;
      if (this.editedItem.oneDevicePolicy && !this.editedItem.twoDevicePolicy) {
        this.editedItem.defaultPolicy = "OneDevice";
      } else if (
        !this.editedItem.oneDevicePolicy &&
        this.editedItem.twoDevicePolicy
      ) {
        this.editedItem.defaultPolicy = "TwoDevice";
      }
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (this.editedItem.deviceMakeId == null) {
        proceed = false;
        confirm("Please fill in a device make.");
      }
      if (this.editedItem.deviceTypeId == null) {
        proceed = false;
        confirm("Please fill in a device type.");
      }
      if (proceed == true) {
        Api()
          .post("/deviceMakeModels", {
            accountCode: this.editedItem.accountCode,
            name: this.editedItem.name,
            cardImage: this.editItem.cardImage,
            deviceMakeId: this.editedItem.deviceMakeId,
            deviceTypeId: this.editedItem.deviceTypeId,
            isHsi: this.editedItem.isHsi,
            isWifi: this.editedItem.isWifi,
            isVoip: this.editedItem.isVoip,
            sellable: this.editedItem.sellable,
            twoGhzWifi: this.editedItem.isWifi
              ? this.editedItem.twoGhzWifi
              : false,
            fiveGhzWifi: this.editedItem.isWifi
              ? this.editedItem.fiveGhzWifi
              : false,
            ports: this.editedItem.ports,
            description: this.editedItem.description,
            priceInclVat: this.editedItem.priceInclVat,
            image: this.editedItem.image,
            oneDevicePolicy: this.editedItem.oneDevicePolicy,
            twoDevicePolicy: this.editedItem.twoDevicePolicy,
            defaultPolicy: this.editedItem.defaultPolicy,
            isHeadend: this.editedItem.isHeadend,
            isCpe: this.editedItem.isCpe,
            isWireless: this.editedItem.isWireless,
            distanceRange: this.editedItem.isWireless?this.editedItem.distanceRange:null,
            angleRange: this.editedItem.isWireless?this.editedItem.angleRange:null,
            isDeleted: this.editedItem.isDeleted,
            isActive: this.editedItem.isActive,
          })
          .then((response) => {
            this.fetchDeviceMakeModels();
          });
        this.close();
      }
    },
  },
};
</script>